/** @jsx isolateComponent */

import { capitalize } from 'lodash';

import { FlexLayout, Modal } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Button, Margin, Text } from '@zapier/design-system';

import { useSize } from '@zapier/design-system-revenue/src/utils';

type Props = {
  irreversibleType: 'promotional' | 'legacy';
  onClose: () => void;
  onContinue: () => void;
};

/**
 * A modal that warns the user that once they switch away from
 * their current plan, they can't return to that plan.
 */
export const IrreversiblePlanChangeModal = ({
  irreversibleType,
  onClose,
  onContinue,
}: Props) => {
  const size = useSize();

  return (
    <Modal
      fullStoryEventName="Viewed Legacy Plan Change Modal"
      onClose={onClose}
    >
      <Text tag="h1" type="header700">
        Change {capitalize(irreversibleType)} Plan?
      </Text>

      <Margin margin="20px 0 40px">
        <Text tag="p" type="bodyText800">
          Once you change your plan, you'll be unable to go back to your
          previous plan.
        </Text>
      </Margin>

      <FlexLayout direction={size === 'small' ? 'column' : 'row'}>
        <Button isFullWidth={size === 'small'} onClick={onContinue}>
          Yes, Change Plan
        </Button>

        <Button color="white" isFullWidth={size === 'small'} onClick={onClose}>
          No, Cancel
        </Button>
      </FlexLayout>
    </Modal>
  );
};
